export class ProfitModel {
  [key: string]: number;

  public profitValue!: number;
  public fixedProfit!: number;
  public variableProfit!: number;
  public totalFixedProfit!: number;
  public totalVariableProfit!: number;
}
